
import React from 'react';
import { Helmet } from 'react-helmet';
import AdminLayout from '@/components/admin/AdminLayout';
import { Button } from '@/components/ui/button';
import { ArrowLeft, RefreshCw } from 'lucide-react';
import { Link } from 'react-router-dom';

interface AdminPageBaseProps {
  title: string;
  description?: string;
  children: React.ReactNode;
  onRefresh?: () => void;
  loading?: boolean;
  showBackButton?: boolean;
}

export default function AdminPageBase({
  title,
  description,
  children,
  onRefresh,
  loading = false,
  showBackButton = true
}: AdminPageBaseProps) {
  return (
    <AdminLayout>
      <Helmet>
        <title>{title} | Grandpal Admin</title>
      </Helmet>
      
      <div className="container mx-auto px-4 py-8">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center gap-4">
            {showBackButton && (
              <Link to="/admin/tools">
                <Button variant="ghost" size="sm">
                  <ArrowLeft className="h-4 w-4 mr-2" />
                  Back to Dashboard
                </Button>
              </Link>
            )}
            <div>
              <h1 className="text-3xl font-bold">{title}</h1>
              {description && (
                <p className="text-muted-foreground mt-1">{description}</p>
              )}
            </div>
          </div>
          
          {onRefresh && (
            <Button 
              variant="outline" 
              onClick={onRefresh}
              disabled={loading}
            >
              <RefreshCw className={`h-4 w-4 mr-2 ${loading ? 'animate-spin' : ''}`} />
              Refresh
            </Button>
          )}
        </div>
        
        {children}
      </div>
    </AdminLayout>
  );
}
